<template>
  <div class="error-page">
    <div class="img"></div>
    <div class="content">
      <div class="uploadLicence">
        <el-form ref="form" :model="form" label-width="100px" size="medium" width="80%" class="form">
          <!-- <el-form-item label="MAC地址">
            <el-input
              v-for="(item,index) in form.ipAddressList"
              :key="index"
              v-model="form.ipAddressList[index]"
              class="ip"
              @blur="checkIp(item,index)"
            ></el-input>
            <el-button type="primary" icon="el-icon-plus" class="btn" @click="addIpAddress"></el-button>
            <el-button type="primary" icon="el-icon-delete" class="btn" @click="delIpAddress"></el-button>
            <el-button type="primary" class="serialBtn" @click="getSerialNumber">获取序列号</el-button>
          </el-form-item>
          <el-form-item label="序列号">
            <el-input v-model="form.serialNumber" :disabled="true" class="serialNumber"></el-input>
            <el-button
              id="copyIpAddress"
              type="primary"
              class="copyBtn"
              :data-clipboard-text="form.serialNumber"
              @click="copyIpAddress"
            >
              复制
            </el-button>
          </el-form-item> -->
          <el-form-item label="公钥">
            <el-input v-model="form.publicKey" type="textarea" :autosize="{ minRows: 4, maxRows: 10 }" class="publicKey"></el-input>
          </el-form-item>
          <el-form-item label="上传文件">
            <el-upload
              class="upload-demo"
              multiple
              :limit="1"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="changeFile"
              action
              :disabled="isSelectFile"
            >
              <el-button size="small" type="primary" @click="upload">点击上传</el-button>
              <span slot="tip" class="el-upload__tip">只能上传licence文件，且不超过500kb</span>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Form',
  data() {
    return {
      form: {
        // ip地址
        ipAddressList: [''],
        // 序列号
        serialNumber: '',
        // 公钥
        publicKey: '',
        // license文件
        fileList: [{ name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }, { name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }]
      },
      ipList: [],
      isSelectFile: true
    }
  },
  mounted() {
    // console.log(this.$route.query);
    if (this.$route.query && this.$route.query.message) {
      this.$message.error(this.$route.query.message);
    }
  },
  methods: {
    //校验Ip
    checkIp(item, index) {
      if (!this.checkMac(item)) {
        this.$message({
          message: '输入的MAC地址不正确',
          type: 'warning'
        })
        this.$set(this.form.ipAddressList, index, '');
      }
    },
    //获取序列号
    getSerialNumber() {
      this.ipList = [];
      this.form.ipAddressList.forEach((item) => {
        if (item) {
          this.ipList.push(item);
        }
      })
      if (this.ipList.length <= 0) {
        this.$message({
          message: '输入的IP地址不能为空',
          type: 'warning'
        })
        return
      }
      let mac = {
        'mac': this.ipList.join('|')
      };
      this.form.serialNumber = JSON.stringify(mac);
    },
    // 增加IP地址输入框
    addIpAddress() {
      let ipAddress = '';
      this.form.ipAddressList.push(ipAddress);
    },
    // 删除IP地址输入框
    delIpAddress() {
      this.form.ipAddressList.splice(this.form.ipAddressList.length - 1, 1);
    },
    // 复制MAC地址
    copyIpAddress() {
      console.log(this.$ts.copyText('copyIpAddress'));
      if (this.$ts.copyText('copyIpAddress')) {
        this.$message({
          message: '复制成功',
          type: 'success'
        })
      } else {
        this.$message({
          message: '复制失败',
          type: 'success'
        })
      }
    },
    upload() {
      if (!this.form.publicKey) {
        this.$message({
          message: '公钥不能为空',
          type: 'warning'
        })
        this.isSelectFile = true
        return;
      } else {
        this.isSelectFile = false
      }
    },
    changeFile(file) {
      if (file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length) !== 'dat') {
        this.$message({
          message: '文件格式不正确',
          type: 'warning'
        })
      } else {
        let formData = new FormData();
        formData.append('file', file.raw);
        formData.append('key', this.form.publicKey.replace(/\s+/g, ''));
        this.$fetch('/common/licence/licenceUpload.json', formData).then((response) => {
          if (response.success) {
            this.$message({
              type: 'success',
              message: '上传成功，请重新登录'
            })
            this.$router.push({ path: this.$config.LOGIN_PAGE });
            this.$store.dispatch('clearUserCache');
            this.$log.info('用户退出登录成功');
          } else {
            this.$message.error(response.msgContent)
          }
        })
      }

    },
    //校验MAC地址
    checkMac(mac) {
      return /(([a-f0-9]{2}:)|([a-f0-9]{2}-)){5}[a-f0-9]{2}/gi.test(mac)
    }
  }

}
</script>

<style lang="scss" scoped >
.error-page {
  // background: #152a42;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;

  .img {
    margin-right: 80px;
    height: 360px;
    width: 100%;
    max-width: 430px;
    background-image: url('../../../common/assets/images/404.svg');
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: contain;
  }

  .content {
    .uploadLicence {
      .form {
        padding: 20px;
        // border: 1px solid #596f94;
        border-radius: 5px;
        .ip {
          width: 100px;
          margin-right: 10px;
        }

        .btn {
          width: 45px;
          margin-left: 10px;
          // background-color: #339EFF;
        }

        .copyBtn {
          width: 60px;
          margin-left: 10px;
          // background-color: #339EFF;
        }

        .serialNumber {
          width: 120px;
        }

        .publicKey {
          width: 100%;
        }

        .el-upload__tip {
          display: inline-block;
          margin-left: 10px;
          margin-top: 0;
        }

        .serialBtn {
          width: 150px;
          margin-left: 10px;
          // background-color: #339EFF;
        }
      }
    }
  }
}
</style>
<style lang="css">
.error-page .el-form-item__label {
  font-size: 16px;
}
</style>